import { render } from "./FormCaption.vue?vue&type=template&id=67f8fd8f"
import script from "./FormCaption.vue?vue&type=script&lang=js"
export * from "./FormCaption.vue?vue&type=script&lang=js"
script.render = render

export default script